import { JobTitle } from '@cycle-app/graphql-codegen';

export const jobsLabel: Record<JobTitle, string> = {
  [JobTitle.ProductManagement]: 'Product',
  [JobTitle.Design]: 'Design',
  [JobTitle.Tech]: 'Tech',
  [JobTitle.Business]: 'Customer-facing',
  [JobTitle.FounderCLevel]: 'Founder/C-level',
};
